import { api, ApiError } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

/** Every figure is null when its source is not connected and synced (`coverage`): null is "can't see", never zero. */
export interface PipelineCoverageResult {
  coverage: SourceCoverage;
  rawPipelineCents: number | null;
  weightedPipelineCents: number | null;
  collectedCents: number | null;
  projectedCents: number | null;
  goalCents: number | null;
  remainingGapCents: number | null;
  coverageRaw: number | null;
  coverageWeighted: number | null;
  benchmark: number;
  status: 'healthy' | 'tight' | 'at-risk' | 'unknown' | null;
  daysLeftInQuarter: number;
  narrative: string | null;
}

/** Returned when the endpoint 404s: nothing is visible, so nothing is claimed. */
const NOT_CONNECTED: PipelineCoverageResult = {
  coverage: { crm: false, money: false, mailbox: false, contact: false },
  rawPipelineCents: null, weightedPipelineCents: null, collectedCents: null,
  projectedCents: null, goalCents: null, remainingGapCents: null,
  coverageRaw: null, coverageWeighted: null, benchmark: 3, status: null,
  daysLeftInQuarter: 90, narrative: null,
};
export async function getPipelineCoverage(): Promise<PipelineCoverageResult> {
  try {
    return await api('/v1/pipeline-coverage');
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return NOT_CONNECTED;
    throw err;
  }
}
